import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  hideShare,
  displayLoginPrompt,
  toggleMobileDrawer
} from "../../actions";
import Header from "../../components/Layout/Header";
import SidebarContainer from "../../containers/Tools/SidebarContainer";
import ActiveToolContainer from "../../containers/Tools/ActiveToolContainer";
import CanvasContainer from "../../containers/Canvas/CanvasContainer";
import ReviewLink from "../../components/Canvas/Controls/ReviewLink";
import Share from "../../components/Share";
import Zoom from "../../components/Zoom";
import UploadModal from "../../components/UploadModal";
import LoginPrompt from "../../components/LoginPrompt";
import withRouter from "../../services/utils/withRouter";

class Customize extends React.Component {
  state = {
    toolsVisible: true,
    shareClosing: false,
    loginPromptClosing: false,
    redirect: false,
    isZoomed: false
  };

  componentDidMount() {
    // Initialize mobile drawer state based on screen size
    const isMobile = window.innerWidth <= 768;
    if (isMobile) {
      // On mobile, drawer starts closed by default
      this.props.toggleMobileDrawer(false);
    } else {
      // On desktop, drawer starts open by default
      this.props.toggleMobileDrawer(true);
    }
  }

  toggleTools = () => {
    // Get current screen size
    const isMobile = window.innerWidth <= 768;

    this.setState((prevState) => {
      const newToolsVisible = !prevState.toolsVisible;
      console.log(
        "Customize - toggleTools called, isMobile:",
        isMobile,
        "old state:",
        prevState.toolsVisible,
        "new state:",
        newToolsVisible
      );

      // Update Redux state for drawer - always update this regardless of platform
      this.props.toggleMobileDrawer(newToolsVisible);
      console.log("Dispatched toggleMobileDrawer with:", newToolsVisible);

      return { toolsVisible: newToolsVisible };
    });
  };

  handleZoom = () => {
    this.setState({ isZoomed: !this.state.isZoomed });
  };

  handleCloseShare = () => {
    this.setState({ shareClosing: true });

    setTimeout(() => {
      this.setState({ shareClosing: false });
      this.props.hideShare();
    }, 300);
  };

  handleCloseLoginPrompt = () => {
    this.setState({ loginPromptClosing: true });

    setTimeout(() => {
      this.setState({ loginPromptClosing: false });
      this.props.displayLoginPrompt(false);
    }, 300);
  };

  UNSAFE_componentWillUpdate(prevProps) {
    // Redirect to new design ID if the ID changes after saving
    if (this.props.design.id && prevProps.design.id !== this.props.design.id) {
      this.setState({
        redirect: true
      });
    }
  }

  areAnyColorsOutOfStock() {
    if (this.props.user.loggedIn && this.props.user.isAdmin) {
      return false;
    }

    for (let d in this.props.design.layer_set) {
      if (
        this.props.design.layer_set[d].has_color !== null &&
        this.props.design.layer_set[d].has_color !== false &&
        this.props.design.layer_set[d].color !== null &&
        this.props.design.layer_set[d].color.out_of_stock_until !== ""
      ) {
        return true;
      }
    }
    return false;
  }

  render() {
    const { params } = this.props;
    const designId = this.props.design.id,
      activeTool = this.props.activeToolCollection.activeTool.toLowerCase(),
      updateUrl = `/${designId}/customize/${activeTool}`;

    return (
      <div className="wrapper">
        {this.state.redirect && (
          // Redirect if design ID changes
          <Navigate
            to={{ pathname: updateUrl, search: this.props.location.search }}
          />
        )}

        <div className="content">
          <Header
            currentPage="customize"
            routeId={this.props.params.id}
            numInvalidElements={this.props.design.numInvalidElements}
            location={this.props.location}
            areAnyColorsOutOfStock={this.areAnyColorsOutOfStock()}
          />

          {
            // Verify that design state is loaded
            this.props.design && (
              <div className="canvas-container">
                <SidebarContainer
                  routeId={this.props.params.id}
                  location={this.props.location}
                  toggleTools={this.toggleTools}
                />
                <ActiveToolContainer
                  routeId={this.props.params.id}
                  location={this.props.location}
                />
                <ReviewLink
                  routeId={this.props.params.id}
                  location={this.props.location}
                  areAnyColorsOutOfStock={this.areAnyColorsOutOfStock()}
                />
                <CanvasContainer
                  toggleTools={this.toggleTools}
                  toolsVisible={this.state.toolsVisible}
                  handleZoom={this.handleZoom}
                />

                {this.props.sharing.active && (
                  <Share
                    handleCloseShare={this.handleCloseShare}
                    shareClosing={this.state.shareClosing}
                  />
                )}
              </div>
            )
          }

          {this.state.isZoomed && <Zoom handleZoom={this.handleZoom} />}

          {this.props.uploadModal && <UploadModal />}

          {this.props.design.displayLoginPrompt && (
            <LoginPrompt
              handleCloseLoginPrompt={this.handleCloseLoginPrompt}
              loginPromptClosing={this.state.loginPromptClosing}
            />
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    design: state.design.present,
    sharing: state.sharing,
    zoomed: state.zoomed.active,
    uploadModal: state.upload.isVisible,
    activeToolCollection: state.activeToolCollection,
    mobileDrawer: state.mobileDrawer
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      hideShare,
      displayLoginPrompt,
      toggleMobileDrawer
    },
    dispatch
  );
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Customize)
);
